import {http} from "../http";

export interface Edv{
    trnRequestType : string;
    PMTCUSTID : string;
    CUSTCIF : string;
    CUSTACC : string;
    AMOUNT : number;
    BENEFNAME : string;
    BENEFADDR : string;
    BENEFACC : string;
    BENEFBANKCODE : string;
    BENEFBANKNAME : string;
    BENEFBANKADDR : string;
    BENEFTAXID : string;
    // INTERMEDBANKCODE : string;
    INTERMEDBANKNAME : string;
    // INTERMEDBANKADDR : string;
    PMTDET : string;
    INFOTOBENEF : string;
    NOTE : string;
    CUSTACCFORCOM : string;
    COMMAMOUNT : string;
}

export const newMoneyTransferEdv = async (request_data: Edv): Promise<Edv> => {
    const { data } = await http.post<Edv>("moneytransfer/edv", request_data);
    return data;
};
